module.exports = __webpack_public_path__ + "static/media/info.b3d490aa.mp3";